export default __webpack_public_path__ + "static/media/Skyshear Tasset.7de30fbf.jpg";